import { Badge } from '@/components/atoms'
import { FormattedI18nString } from '@/utils/FormattedI18nString'
import { useTranslation } from 'react-i18next'
import { EmailExportContent } from './EmailExportContent'

const badgeClassName = 'h-6 w-6 !rounded-[50%]'

const LIST_ITEMS = [
    {
        icon: (
            <Badge variant="linkPrimary" className={badgeClassName}>
                1
            </Badge>
        ),
        text: (
            <FormattedI18nString i18nKey="common.exportByEmail.list.firstListItem" />
        ),
    },
    {
        icon: (
            <Badge variant="linkPrimary" className={badgeClassName}>
                2
            </Badge>
        ),
        text: (
            <FormattedI18nString i18nKey="common.exportByEmail.list.secondListItem" />
        ),
    },
    {
        icon: (
            <Badge variant="linkPrimary" className={badgeClassName}>
                3
            </Badge>
        ),
        text: (
            <FormattedI18nString i18nKey="common.exportByEmail.list.thirdListItem" />
        ),
    },
]

export type ExportByEmailModalContentProps = {
    onSuccess: () => void
    onCancel?: () => void
    onSubmit?: () => Promise<void>
    onSubmitError?: (error: unknown) => void
}

export const ExportByEmailModalContent: React.FC<
    ExportByEmailModalContentProps
> = ({ onSuccess, onCancel, onSubmit, onSubmitError }) => {
    const { t } = useTranslation('translations')

    return (
        <EmailExportContent
            labels={{
                saveButton: t('common.exportByEmail.saveButton'),
                cancelButton: t('common.exportByEmail.cancelButton'),
            }}
            list={LIST_ITEMS}
            handleOnSuccess={onSuccess}
            handleOnCancel={onCancel}
            title={t('common.exportByEmail.list.title')}
            onSubmit={onSubmit}
            onSubmitError={onSubmitError}
        />
    )
}
